import {Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, ViewChild} from '@angular/core';
import { ControlValueAccessor, NgModel, NG_VALUE_ACCESSOR } from '@angular/forms';
import {IwgSelect} from '../../../shared/Models/iwgselect.model';
import {IwgSelectService} from '../../../shared/services/iwgselect.service';
const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ChargeSelectComponent),
  multi: true
};

@Component({
  selector: 'app-charge-select',
  templateUrl: './charge-select.component.html',
  styleUrls: ['./charge-select.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})

export class ChargeSelectComponent implements ControlValueAccessor {
  @Input('iscompliance') iscompliance = 'false';
  @Input('preselectedItemId') preselectedItemId: any;
  @Input('refresh-on-preselect') refreshOnPreselect: boolean;
  @Input('disabled') disabled = false;
  @Input('assignmentid') assignmentid: any;
  @Input('allocationid') allocationid: any;
  @Input('allocationid2') allocationid2: any;
  @Input() helptext = '';
  @Input() required = true;

  @Output() selectionChange = new EventEmitter();
  @ViewChild('charge_id') chargeId: NgModel;

  isLoading = false;
  items = [];
  event: any;
  loadPromise: any;
  isOpen = false;

  private innerValue: any = '';
  get value(): any {return this.innerValue; }
  set value(v: any) {
      if (v !== this.innerValue) {
        this.innerValue = v; this.onChangeCallback(v);
      }
  }
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  writeValue(value: any) {if (value !== this.innerValue) { this.innerValue = value; }}
  registerOnChange(fn: any) {this.onChangeCallback = fn; }
  registerOnTouched(fn: any) {this.onTouchedCallback = fn; }

  constructor(private iwgselectservice: IwgSelectService) { }

  ngOnInit(): void {}

  onOpen(event){
    this.isLoading = true;
    this.get();
  }

  get(setId= false){
    this.iwgselectservice.getCharges({
      limit: 0,
      assignmentid: this.assignmentid,
      allocationid: this.allocationid,
      allocationid2: this.allocationid2,
      format_hint: 'engagement_cost_type'
    }).subscribe(
      result => {
        this.isLoading = false;
        if (result.apiCallStatus && result.data) {
            this.items = this.getItems(result.data.Data);
          
        }
      },
      error => {
          this.isLoading = false;
          console.log(error);
      });
  }

  onValChange($event){
    this.selectionChange.emit($event.value);
  }

  getItems(response) {
    let items;
    if (response instanceof Array) {
        items = response;
    } else {
        items = response.Data;
    }
    return items;
  }
  objectComparison = function( option, value ) : boolean {
    if (!option || !value) {
      return false;
    }
    return (option.Abbreviation == value || option.ID == value || option.ID === value.ID);
  }

  resetControl(): void {
    this.chargeId.control.reset();
  }
}
